import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWorksheetsAPI } from "./worksheetAPI";

const initialState = {
  results: [],
  current_page: 1,
  total_pages: 1,
  loading: false,
  error: null,
};

export const fetchWorksheets = createAsyncThunk(
  "worksheets/fetchWorksheets",
  async (
    { page, limit = 13, type = null, keyword = null },
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchWorksheetsAPI(page, limit, type, keyword);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const worksheetListSlice = createSlice({
  name: "worksheets",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorksheets.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWorksheets.fulfilled, (state, action) => {
        state.loading = false;
        const { results, current_page, total_pages } = action.payload;
        state.results = results;
        state.current_page = current_page;
        state.total_pages = total_pages;
      })
      .addCase(fetchWorksheets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch worksheets";
      });
  },
});

export default worksheetListSlice.reducer;
